import { useTranslation } from "../i18n";

export function ReadOnlyBanner() {
  const { t } = useTranslation();

  return (
    <div className="sticky top-[3.75rem] z-40 border-b border-amber-500/30 bg-amber-500/10 px-6 py-2.5 backdrop-blur-md">
      <div className="mx-auto flex max-w-7xl items-center justify-center gap-2">
        <span aria-hidden="true">✅</span>
        <p className="text-sm font-semibold text-amber-700 dark:text-amber-300">
          {t("board.readOnly")}
        </p>
      </div>
    </div>
  );
}
